/**
 * CSS for optimizing text legibility
 *
 * @example
 * // styles as object
 * const styles = {
 *   ...optimizeLegibility(),
 * };
 *
 * // emotion usage
 * styled.div`
 *   ${optimizeLegibility()}
 * `;
 */
export default function optimizeLegibility() {
  return {
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    fontFeatureSettings: 'liga',
    textRendering: 'optimizeLegibility'
  };
}